var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, useEffect, useState } from "react";
import Background, { BackgroundType } from "../components/Background";
import Welcome from "../components/Welcome";
import { createUseStyles, useTheme } from "react-jss";
import { useNavigate, useParams } from "react-router-dom";
import { EngageContext, ErrorType } from "../context";
import { EngageMessageType } from "engage-common/messages";
import Button from "../components/Button";
import DisplayText, { TextVariant } from "../components/DisplayText";
import TextField from "../components/TextField";
import { isUndefined } from "engage-common/utils";
import JoinTeam from "../components/teams/JoinTeam";
import { TeamMode } from "engage-common/types";
var useStyles = createUseStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f;
    return ({
        root: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
        },
        actionButton: {
            display: "block",
            margin: [32, "auto"],
            padding: [16, 16],
            width: (_a = theme.welcome.actionButton.width) !== null && _a !== void 0 ? _a : "100%",
            color: theme.welcome.actionButton.color,
            border: theme.welcome.actionButton.border,
            borderRadius: 30,
            fontWeight: (_b = theme.welcome.actionButton.fontWeight) !== null && _b !== void 0 ? _b : 400,
        },
        container: {
            margin: { top: 16 },
            display: "flex",
            flexDirection: "column",
            padding: 8
        },
        loginForm: {
            margin: { top: 96 },
            flex: 1
        },
        input: {
            color: (_d = (_c = theme.welcome.textField) === null || _c === void 0 ? void 0 : _c.textColor) !== null && _d !== void 0 ? _d : "white",
            width: (_f = (_e = theme.welcome.textField) === null || _e === void 0 ? void 0 : _e.width) !== null && _f !== void 0 ? _f : "100%",
        }
    });
});
var JoinState;
(function (JoinState) {
    JoinState[JoinState["nickname"] = 0] = "nickname";
    JoinState[JoinState["team"] = 1] = "team";
})(JoinState || (JoinState = {}));
var JoinPage = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var navigate = useNavigate();
    var lobbyID = useParams().lobbyID;
    var classes = useStyles();
    var _q = useContext(EngageContext), sendMessage = _q.sendMessage, lobbyValidation = _q.lobbyValidation, errorMap = _q.errorMap;
    var _r = useState(JoinState.nickname), joinState = _r[0], setJoinState = _r[1];
    var _s = useState({
        nickname: ""
    }), formValues = _s[0], setFormValues = _s[1];
    var handleInputChange = function (e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value;
        setFormValues(__assign(__assign({}, formValues), (_a = {}, _a[name] = value, _a)));
    };
    var setFormValue = function (key, value) {
        setFormValues(function (current) {
            var _a;
            return (__assign(__assign({}, current), (_a = {}, _a[key] = value, _a)));
        });
    };
    var onJoin = function (e) {
        e.preventDefault();
        if ((lobbyValidation === null || lobbyValidation === void 0 ? void 0 : lobbyValidation.teamMode) === TeamMode.Choose) {
            setJoinState(JoinState.team);
        }
        else {
            sendMessage(__assign({ type: EngageMessageType.JoinLobby, lobbyID: lobbyID !== null && lobbyID !== void 0 ? lobbyID : "" }, formValues));
        }
    };
    useEffect(function () {
        if (isUndefined(lobbyValidation)) {
            sendMessage({ type: EngageMessageType.CheckLobby, lobbyID: lobbyID !== null && lobbyID !== void 0 ? lobbyID : "" });
        }
    }, [lobbyID, lobbyValidation, sendMessage]);
    useEffect(function () {
        if (lobbyValidation && !lobbyValidation.askForNickname && sendMessage) {
            sendMessage({ type: EngageMessageType.JoinLobby, lobbyID: lobbyID !== null && lobbyID !== void 0 ? lobbyID : "", nickname: "" });
        }
    }, [sendMessage, lobbyValidation, lobbyID]);
    useEffect(function () {
        if (errorMap === null || errorMap === void 0 ? void 0 : errorMap[ErrorType.NoLobby]) {
            navigate("/");
        }
    }, [errorMap, navigate]);
    if (!(lobbyValidation === null || lobbyValidation === void 0 ? void 0 : lobbyValidation.askForNickname)) {
        return React.createElement(React.Fragment, null);
    }
    var theme = useTheme();
    return (React.createElement(Background, { type: BackgroundType.Welcome, showLicense: true, showSponsor: true }, joinState === JoinState.nickname ?
        React.createElement("div", { className: classes.root },
            React.createElement(Welcome, { title: lobbyValidation === null || lobbyValidation === void 0 ? void 0 : lobbyValidation.lobbyTitle }),
            React.createElement("div", { className: classes.container },
                React.createElement("form", { onSubmit: onJoin, className: classes.loginForm },
                    React.createElement(TextField, { labelText: "Nickname", name: "nickname", autoFocus: true, required: true, value: formValues.nickname, onChange: handleInputChange, className: classes.input, variant: "filled", backgroundColor: (_b = (_a = theme.welcome.textField) === null || _a === void 0 ? void 0 : _a.bgColor) !== null && _b !== void 0 ? _b : "#1D1F4266", backgroundHoverColor: (_d = (_c = theme.welcome.textField) === null || _c === void 0 ? void 0 : _c.bgHoverColor) !== null && _d !== void 0 ? _d : "#1D1F4299", foregroundColor: (_f = (_e = theme.welcome.textField) === null || _e === void 0 ? void 0 : _e.labelColor) !== null && _f !== void 0 ? _f : "lightgray", foregroundHoverColor: (_h = (_g = theme.welcome.textField) === null || _g === void 0 ? void 0 : _g.textColor) !== null && _h !== void 0 ? _h : "white", foregroundFocusColor: (_k = (_j = theme.welcome.textField) === null || _j === void 0 ? void 0 : _j.textColor) !== null && _k !== void 0 ? _k : "lightgray", textColor: (_m = (_l = theme.welcome.textField) === null || _l === void 0 ? void 0 : _l.textColor) !== null && _m !== void 0 ? _m : "white" }),
                    React.createElement(Button, { className: classes.actionButton, type: "submit", backgroundColor: (_o = theme.welcome.actionButton.bgColor) !== null && _o !== void 0 ? _o : "secondary", lighten: theme.welcome.actionButton.lighten },
                        React.createElement(DisplayText, { variant: TextVariant.smallButton, color: (_p = theme.welcome.actionButton.color) !== null && _p !== void 0 ? _p : "white" }, "Join"))))) :
        React.createElement(JoinTeam, { setFormValue: setFormValue, formValues: formValues, lobbyValidation: lobbyValidation })));
};
export default JoinPage;
//# sourceMappingURL=join.js.map